import { render } from "./Especialidad_Medico.vue?vue&type=template&id=7b6a8a02"
import script from "./Especialidad_Medico.vue?vue&type=script&lang=js"
export * from "./Especialidad_Medico.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__